import List from './TeacherList'
import Registration from './TeacherRegistration'
import Details from './TeacherDetails'
const exportObj = {
    List,
    Registration,
    Details,
}

export default exportObj